class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.bindEvents();

    document.addEventListener("keydown", this.handleKeyDown.bind(this));
  }
  bindEvents() {
    if (document.querySelector("[data-cart-drawer-btn]")) {
      document
        .querySelector("[data-cart-drawer-btn]")
        .addEventListener("click", this.openDrawer.bind(this));
    }
    this.querySelectorAll("[data-close-drawer]").forEach((button) =>
      button.addEventListener("click", this.closeDrawer.bind(this)),
    );
    this.dialogEvents();
  }
  dialogEvents() {
    let focusElementDrawer = "";
    Array.from(this.querySelectorAll(".cart-modal-button")).forEach(
      function (button) {
        button.addEventListener(
          "click",
          function (e) {
            let modal = button.dataset.modal;
            let dialog = this.querySelector(`cart-dialog#${modal}`);
            if (dialog) {
              dialog.style.display = "block";
              setTimeout(function () {
                dialog.classList.add("active");
                setTimeout(function () {
                  focusElementDrawer = button;
                  trapFocusElements(dialog);
                }, 500);
              }, 200);
            }
          }.bind(this),
        );
      }.bind(this),
    );
    Array.from(this.querySelectorAll(".cart-dialog-close")).forEach(
      function (button) {
        button.addEventListener("click", function (e) {
          e.preventDefault();
          button.closest("cart-dialog").classList.remove("active");
          trapFocusElements(document.querySelector("cart-drawer"));
          setTimeout(function () {
            button.closest("cart-dialog").style.display = "none";
            if (focusElementDrawer) {
              focusElementDrawer.focus();
            }
            focusElementDrawer = "";
          }, 400);
        });
      },
    );
  }
  openDrawer(event) {
    event.preventDefault();
    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((html) => {
        this.querySelector(".drawer-inner-card").innerHTML =
          this.getSectionInnerHTML(html, ".drawer-inner-card");
        this.classList.add("open");
        document.querySelector("body").classList.add("no-scroll");
        this.querySelectorAll("[data-close-drawer]").forEach((button) =>
          button.addEventListener("click", this.closeDrawer.bind(this)),
        );
        setTimeout(function () {
          focusElement = event.target;
          trapFocusElements(document.querySelector("cart-drawer"));
        }, 500);
        this.dialogEvents();

        setTimeout(function () {
          fetch("/cart.js")
            .then((response) => response.json())
            .then((data) => {
              let totalprice = data.total_price;
              shippingBarProgress(totalprice);
            });
        }, 500);
      })

      .catch((e) => {
        console.error(e);
      });
  }
  renderContents(parsedState) {
    if (!parsedState) return;
    this.getSectionsToRender().forEach((section) => {
      if (document.getElementById(section.id)) {
        let parseElement = this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector,
        );
        document
          .getElementById(section.id)
          .querySelector(section.selector).innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector,
        );
        let totalCount = new DOMParser()
          .parseFromString(parsedState.sections[section.id], "text/html")
          .querySelector("#cart-drawer-body")
          .getAttribute("data-cart-count");
        if (document.querySelector("[data-item-count]")) {
          if (
            document
              .querySelector("[data-item-count]")
              .classList.contains("hidden")
          ) {
            document
              .querySelector("[data-item-count]")
              .classList.remove("hidden");
          }
          if (totalCount == 0) {
            document.querySelector("[data-item-count]").classList.add("hidden");
          } else if (totalCount < 100) {
            document.querySelector("[data-item-count]").textContent =
              totalCount;
          } else {
            document.querySelector("[data-item-count]").textContent = "99+";
          }
        }
        if (document.querySelector("[data-cart-price]")) {
          let totalprice = parseInt(
            document.querySelector("[data-cart-price]").dataset.cartPrice,
          );
          shippingBarProgress(totalprice);
        }
        this.dialogEvents();
        this.querySelectorAll("[data-close-drawer]").forEach((button) =>
          button.addEventListener("click", this.closeDrawer.bind(this)),
        );
      }
    });
  }
  showAddedItem(opener, variantId) {
    if (!this.classList.contains("open")) {
      window.dispatchEvent(new CustomEvent("amaro:product-added"));
      return;
    }
    const body = this.querySelector("#cart-drawer-body");
    if (body) body.scrollTop = 0;
    cancelAnimationFrame(this.addedFocusFrame);
    this.addedFocusFrame = requestAnimationFrame(() => {
      if (!this.classList.contains("open")) return;
      trapFocusElements(this);
      const item = this.querySelector(`[data-quantity-variant-id="${Number(variantId)}"]`)?.closest(".cart-items-product");
      if (body && item) body.scrollTop = Math.max(0, item.getBoundingClientRect().top - body.getBoundingClientRect().top + body.scrollTop - 12);
    });
  }
  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        section: "cart-drawer",
        selector: ".drawer-inner-card",
      },
    ];
  }
  getSectionInnerHTML(html, selector = ".drawer-inner-card") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }
  closeDrawer(event) {
    event.preventDefault();
    cancelAnimationFrame(this.addedFocusFrame);
    const closeElement = event.currentTarget;
    if (this.classList.contains("open")) {
      this.classList.remove("open");
      document.querySelector("body").classList.remove("no-scroll");
    }
    if (focusElement) {
      focusElement.focus();
    }
    focusElement = "";
    removeTrapFocus();
  }
  handleKeyDown(event) {
    if (event.key === "Escape" && this.classList.contains("open")) {
      this.closeDrawer(event); // Call closeDrawer when Escape is pressed
    }
  }
}

customElements.define("cart-drawer", CartDrawer);
